module.exports = __webpack_public_path__ + "media/images/banner_logos_dark-e66c31d9.png";